export default {
    //get active ANNOUNCEMENTS
    GET_ACTIVE_ANNOUNCEMENTS_REQUEST: 'GET_ACTIVE_ANNOUNCEMENTS_REQUEST',
    GET_ACTIVE_ANNOUNCEMENTS_SUCCESS: 'GET_ACTIVE_ANNOUNCEMENTS_SUCCESS',
    GET_ACTIVE_ANNOUNCEMENTS_FAIL: 'GET_ACTIVE_ANNOUNCEMENTS_FAIL',

    //loading
    ADD_ANNOUNCEMENTS_LOADING: 'ADD_ANNOUNCEMENTS_LOADING'
};

